import { DEFAULT_LOCALE } from '../constants/price';

export const getPercentageChange = (
  oldNumber: number,
  newNumber: number,
): number => {
  const decreaseValue = oldNumber - newNumber;

  return oldNumber > 0 ? (decreaseValue / oldNumber) * 100 : 0;
};

export const formatPercent = (
  value: number,
  minimumFractionDigits = 0,
): string => {
  return Number(value / 100).toLocaleString(DEFAULT_LOCALE, {
    style: 'percent',
    minimumFractionDigits,
  });
};

export const formatTwoDigitDate = (date: number, locale = 'fr-FR'): string => {
  return new Date(date * 1000).toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
